import React from 'react';
import { Box, Flex, Text, Link, IconButton, VStack, useColorModeValue } from '@chakra-ui/react';
import { FaYoutube, FaSpotify, FaInstagram, FaXTwitter, FaTiktok, FaEnvelope } from 'react-icons/fa6'; // Using Fa6 for more icons

const Footer = ({ socialLinks, contactEmail }) => {
  const footerBg = useColorModeValue('brand.800', 'brand.800');
  const textColor = useColorModeValue('brand.600', 'brand.600');
  const linkColor = useColorModeValue('brand.accent', 'brand.accent');
  const linkHoverColor = useColorModeValue('brand.secondaryAccent', 'brand.secondaryAccent');

  // Determine appropriate icon for each social link dynamically
  const getSocialIcon = (platform) => {
    switch (platform.toLowerCase()) {
      case 'youtube': return <FaYoutube />;
      case 'spotify': return <FaSpotify />;
      case 'instagram': return <FaInstagram />;
      case 'twitter': return <FaXTwitter />; // For "X" (formerly Twitter)
      case 'tiktok': return <FaTiktok />;
      default: return null;
    }
  };

  return (
    <Box
      bg={footerBg}
      py={8}
      mt={10}
      px={4}
      borderRadius="xl" // Rounded corners for the footer
      boxShadow="inner" // Inner shadow for subtle depth
      mx={{ base: 2, md: 4, lg: 8 }} // Margin on left/right
      mb={{ base: 2, md: 4, lg: 6 }} // Margin on bottom
    >
      <VStack spacing={6}>
        {/* Social Media Links */}
        <Flex wrap="wrap" justifyContent="center" gap={{ base: 3, md: 5 }}>
          {socialLinks && Object.entries(socialLinks).map(([platform, url]) => (
            getSocialIcon(platform) && url && ( // Render only if icon and URL exist
              <IconButton
                key={platform}
                as={Link}
                href={url}
                isExternal // Opens in new tab
                aria-label={`Link to ${platform}`}
                icon={getSocialIcon(platform)}
                size="lg"
                variant="ghost" // Ghost variant for subtle icons
                color={linkColor}
                _hover={{ color: linkHoverColor, transform: 'scale(1.1)' }}
                borderRadius="full"
              />
            )
          ))}
        </Flex>

        {/* Contact Email */}
        {contactEmail && (
          <Link
            href={`mailto:${contactEmail}`}
            color={linkColor}
            fontSize="lg"
            display="flex"
            alignItems="center"
            _hover={{ color: linkHoverColor }}
          >
            <FaEnvelope style={{ marginRight: '8px' }} /> {contactEmail}
          </Link>
        )}

        {/* Copyright Information */}
        <Text fontSize="sm" color={textColor} textAlign="center" mt={4}>
          © {new Date().getFullYear()} Ad Proteum. All rights reserved.
        </Text>
      </VStack>
    </Box>
  );
};

export default Footer;